import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getScopeName, getViewName } from '../../utils/nameFormat';
export const removeFilterScopeStmtInstruction = `
## Remove Filters for Scopes

To remove a filter from a scope:
- Syntax: \`remove filter scope <scope_name> in <view_name>;\`
- Example: \`remove filter scope ${getScopeName({ entityName: 'PackageReservation' })} in ${getViewName({
    entityName: 'PackageReservation',
    viewType: 'dataGrid',
})};\`
`;
export const stmtRemoveFilterScope = ({ scopeName, viewName }) => {
    return `remove filter scope ${scopeName} in ${viewName};`;
};
export const removeFilterScopeHandler = createStructureStatementHandler({
    type: 'remove filter scope',
    parse: line => {
        const match = /^remove filter scope (?<scopeName>\w+) in (?<viewName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'remove filter scope',
                scopeName: match.groups.scopeName,
                viewName: match.groups.viewName,
            }
            : null;
    },
    apply: (stmt, builder) => builder.updateStructure(it => it.removeFilterScope({
        scopeName: stmt.scopeName,
        viewName: stmt.viewName,
    })),
});
//# sourceMappingURL=RemoveFilterScopeStmt.js.map